
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const neve8801: IProductData = {
  id: "neve-8801",
  name: "Neve Mono Channel Strip",
  description: "The complete channel strip from the world’s most accomplished studio console – the 88RS.",
  specialOrder: true,
  images: ["/img/neve_8801_front.png", "/img/neve_8801_back.png"],
  details: [{
    label: "Description",
    markdown: `
The 8801 microphone preamp uses an exclusive Marinair® specification transformer to deliver a high gain output and ultimate tonality across various signal sources.

The 8801’s sweepable high and low pass filters are independent of the main EQ section,  providing control of incoming signals before they hit the main processors. For further transient control, the filters can be added to the compressor sidechain.

The 8801 dynamics section features a supremely powerful VCA compressor/limiter with variable/auto release, switchable fast/slow attack times, stereo linking options and five-stage gain reduction metering. In addition, the 8801 dynamics section features a gate/expander with separate gain reduction metering, key input option, hysteresis control and an invert feature for use in broadcast applications.

The 8801 EQ section provides four bands of control across the frequency spectrum, ideal for sculpting sounds and perfecting the signal of any instrument. Two fully parametric mid bands with continuously variable pots frequency selection, +/- 20db of gain and Q bandwidth from 0.7 to 2.0, complement a high and low band with switchable bell curve/shelf options and high Q setting.

The 8801’s audio router feature gives users total control over their signal flow. The balanced insert, EQ, dynamics sections & sidechain filtering can be repositioned at the push of a button from either the front of the unit or from the digital audio routing matrix within the recall software.

Just like the 88RS, the 8801 topology uses a wide bandwidth/high output architecture. The main output gain, controlled by the rotary fader pot, delivers a maximum output of +26dBu, with an incredibly low noise floor. This system, complimented with switchable input & output 7-stage metering, is ideal for perfect gain staging before signals reach the DAW.

Every setting on the 8801 can be recalled quickly, ideal for working on multiple sessions in today’s fast-paced studio workflows. The 8801 can connect via a simple USB connection to any computer system (PC/Mac) to interface with the interactive Neve® recall software program. Routing and switching are handled automatically at the push of a button, while the 8801’s rotary pots are manually tracked to their stored positions in a matter of seconds.

The optional A/D conversion card provides digital output from the 8801. This card uses premium, Neve® quality converters with switchable headroom settings to integrate with any digital system. The digital outputs are in SPDIF, AES 3 and DSD formats, with selectable sample rates of up to 192kHz and clocking options via AES Sync or word clock BNC connections.
`
    }, {
      label: "Specifications",
      markdown: `
• Complete channel strip from the revered 88RS console in a single rackspace
• Hand-built and hand-wired by Neve®  in Burnley, England
• Genuine Neve®  mic preamp with High and Low Pass Filters
• 4-band equalization with highly musical, full-range sound
• 88RS-style compressor and gate
• Insert send and return
• EQ or filters to sidechain
• USB port for direct connection to Mac or PC
• Optional Neve analogue-to-digital converter
`
}, {
  label: "Preamp Specifications",
  markdown: `
• Microphone input impedance (balanced): 1.2k Ohms
• Microphone input headroom: +26dBu (reference 0dBu)
• Microphone input gain range: 0dB to 70dB (using PAD)
• Line input impedance (balanced): 20k Ohms is able to encompass signals from sources referenced to +4dBu or to -10dBu
• Line input headroom: +26dBu (reference 0dBu)
• Line input gain range: -24dB to 24dB
• DI input impedance (balanced): 750k Ohms
• DI input headroom: +20dBu (reference 0dBu)
• DI input gain range: -44dB to +24dB (using PAD)
`
  }, {
    label: "Output Specifications",
    markdown: `
• Line output impedance: <50 Ohms
• Main output Maximum output: +26dBu into 600 Ohms
• Frequency Response: +/- 0.2 dB 10Hz to 20kHz,  +/- 0.5 dB 10Hz to 40kHz Line Input to Main Output
• THD + N: < 0.005% Line Input to Main Output, 20Hz to 20kHz, using a measurement window of 10Hz to 80kHz
• Noise: Line Input to Main Output: < -89dBu
• All the audio blocks in circuit: < -80dBu
• All noise measurements made between 20Hz and 20kHz using a measurement bandwidth 22Hz to 22kHz
`
  }, {
    label: "Dimensions",
    markdown: `
• Width: 48.2cm (19 inches)
• Height: 4.4cm (1.75 inches) (1U)
• Depth: 24cm (9.5 inches) – without the power socket plugged in
• Weight: 3.0kg (6.6 pounds)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/8801-channel-strip/" target="_blank">https://www.ams-neve.com/8801-channel-strip/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MICPRE, HASHTAGS.COMPRESSOR, HASHTAGS.EQ, HASHTAGS.RECORDING, HASHTAGS.LIVE_SOUND, HASHTAGS.ONE_U, HASHTAGS.RACK],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}